import pino from 'pino';

/** 배포 모드용: 구조적 JSON 로그 (수집 파이프라인 친화적) */
export const prodLogger = pino({
  browser: {
    asObject: true, // 브라우저 콘솔에서도 key-value로 보기 좋게
  },
  level: 'warn',
  // 필요시 base: { app: "hancom-sdk-demo" } 등 공통 필드 추가
});
